// Patient Ledger feature — unified payment surface.
//
// The drawer is hosted by `PatientLedgerDrawerHost` (mounted globally,
// alongside GlobalModalManager). Trigger via `useOpenLedgerDrawer`.
//
// This feature owns its own slice (`patientLedger/drawer`) instead of
// piggybacking the global modal stack. A drawer is not a dialog: it has
// its own backdrop, focus trap, scroll lock, and slide animation. Trying
// to host one inside the modal registry's Dialog wrapper led to a long
// list of "fight the wrapper" hacks. With its own host, none of that
// applies.

import { autoRegisterFeature } from '@store/features/factory';

import { patientLedgerFeature } from './store/feature';

autoRegisterFeature(patientLedgerFeature);

export { EligibilityTabContent } from './components/EligibilityTabContent';
export { default as PatientLedgerDrawer } from './PatientLedgerDrawer';
export { PatientLedgerDrawerHost } from './PatientLedgerDrawerHost';
export {
  useCloseLedgerDrawer,
  useOpenEligibilityDetail,
  useOpenLedgerDrawer,
  useOpenPaymentSheet,
} from './store/hooks';
export type {
  LedgerDrawerProps,
  LedgerInitialAction,
  LedgerScope,
  LedgerTab,
  EligibilityDetailRequest,
  PaymentSheetRequest,
  SettleMethod,
  SettlePaymentIntent,
} from './types';
